
import { Component, Vue } from "vue-property-decorator";
import { Action, Mutation, Getter } from "vuex-class";

@Component({})
export default class extends Vue {
  @Action("login/companyLogout")
  public companyLogout!: () => void;
  @Action("login/saleLogout")
  public saleLogout!: () => void;
  @Action("login/memberLogout")
  public memberLogout!: () => void;
  @Action("auth/deauthorize")
  public deauthorize!: () => void;

  @Getter("auth/isCompany")
  public isCompany!: boolean;
  @Getter("auth/isMember")
  public isMember!: boolean;
  @Getter("auth/isSale")
  public isSale!: boolean;

  @Mutation("auth/clearUser")
  public clearUser!: () => void;
  @Mutation("auth/clearRole")
  public clearRole!: () => void;

  private async created() {
    if (this.isCompany) {
      await this.companyLogout();
    } else if (this.isMember) {
      await this.memberLogout();
    } else if (this.isSale) {
      await this.saleLogout();
    }
    this.deauthorize();
    this.$router.push("Login");
    // await this.saleLogout();
    // this.clearUser();
    // this.clearRole();

    // await this.companyLogout();
    // await this.saleLogout();
    // await this.memberLogout();
    // this.$router.push("/");
  }
}
